import { put, call, takeEvery } from 'redux-saga/effects';

import ActionTypes from '../constants/ActionTypes';
import { checkInfraAllocationAPI } from '../api/infra';
import { httpStatusCodes } from '../constants/Http';
import { errorLogger, proctoringUBALogger } from '../utils/trackingUtil';
import {
  ENV_SETUP_TIME_DEFAULT,
  UBA_INFRA_PROVISIONING_ERROR_VERBOSE,
} from '../constants/Constants';

function* checkInfraAllocation({ payload }) {
  try {
    const { assessmentId, isLastCall, isExtendedTest } = payload;
    if (isExtendedTest) {
      proctoringUBALogger(
        UBA_INFRA_PROVISIONING_ERROR_VERBOSE,
        `infra-provisioning: disabled infra provisioning for extended test`
      );
      yield put({
        type: `${ActionTypes.CHECK_INFRA_ALLOCATION}_SUCCESS`,
        payload: {
          isReady: true,
        },
      });
    } else {
      const infraAllocationResp = yield call(
        checkInfraAllocationAPI,
        assessmentId
      );
      if (infraAllocationResp.status === httpStatusCodes.OK) {
        let isReady = infraAllocationResp.data.is_ready;
        if (isLastCall && !isReady) {
          proctoringUBALogger(
            UBA_INFRA_PROVISIONING_ERROR_VERBOSE,
            `infra-provisioning: infra not allocated after ${ENV_SETUP_TIME_DEFAULT} seconds`
          );
          isReady = true;
        }
        yield put({
          type: `${ActionTypes.CHECK_INFRA_ALLOCATION}_SUCCESS`,
          payload: {
            isReady,
          },
        });
      }
    }
  } catch (checkInfraError) {
    yield put({
      type: `${ActionTypes.CHECK_INFRA_ALLOCATION}_SUCCESS`,
      payload: {
        isReady: true,
      },
    });
    if (checkInfraError?.response?.status !== httpStatusCodes.NOT_FOUND) {
      errorLogger(checkInfraError);
    }
  }
}

export default function* infraAllocationSaga() {
  yield takeEvery(ActionTypes.CHECK_INFRA_ALLOCATION, checkInfraAllocation);
}
